import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'

const domContainer = document.querySelector('#search_header_refactor');

window.parentUrl = null

window.addEventListener('message', event => {
  if (typeof event.data === 'string') {
    if (event.data.startsWith('HREF')) {
      window.parentUrl = event.data.split('|')[1]
    }
  }
})

// Toggle behavior based on environment and container structure.
// Use Strict Mode if we're in a development environment. https://react.dev/reference/react/StrictMode
const hasChildNodes = domContainer.hasChildNodes()
const isDevMode = process.env.NODE_ENV === 'development'

if (isDevMode && hasChildNodes) { ReactDOM.hydrate(<React.StrictMode><App/></React.StrictMode>, domContainer) }
else if (isDevMode && !hasChildNodes) { ReactDOM.render(<React.StrictMode><App/></React.StrictMode>, domContainer) }
else if (!isDevMode && hasChildNodes) { ReactDOM.hydrate(<App/>, domContainer) }
else if (!isDevMode && !hasChildNodes) { ReactDOM.render(<App/>, domContainer) }
else { console.log('Configuration error in index.js.') }